
import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export type AccountTab = 'subscription' | 'personal' | 'usage';

export const useAccountTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<AccountTab>('subscription');

  useEffect(() => {
    const tabParam = searchParams.get('tab');
    
    if (tabParam === 'personal') {
      setActiveTab('personal');
    } else if (tabParam === 'usage') {
      setActiveTab('usage');
    } else {
      setActiveTab('subscription');
    }
  }, [searchParams]);

  const handleTabChange = (value: AccountTab) => {
    setActiveTab(value);
    setSearchParams({ tab: value });
  };

  return { activeTab, setActiveTab, handleTabChange };
};
